/* eslint-disable jsx-a11y/alt-text */
/* eslint-disable jsx-a11y/anchor-is-valid */
import React, { Component } from "react";
import { Link, withRouter } from "react-router-dom";
import LanguageSelector from "components/widgets/language/LanguageSelector";
import MobileMenu from "components/header/MobileMenu";
import Guidebar from "components/header/Guidebar";
import Notificationsbar from "components/header/Notificationsbar";
import Profilebar from "components/header/Profilebar";
import Navigation from "components/header/Navigation";

class Header extends Component {
  state = { isMobileMenuVisible: false };

  unlisten = this.props.history.listen((location, action) => {
    if (location.pathname !== this.state.prevPath) {
      this.setState({ isMobileMenuVisible: false });
    }
  });

  toggleButton = React.createRef();

  componentDidMount() {}

  componentWillUnmount = () => {
    this.unlisten();
  };

  toggleMobileMenu = () => {
    if (this.state.isMobileMenuVisible) {
      this.setState({ isMobileMenuVisible: false });
    } else {
      this.setState({ isMobileMenuVisible: true });
    }
  };

  renderMobileMenu = () => {
    if (this.toggleButton.current) {
      if (this.state.isMobileMenuVisible) {
        this.toggleButton.current.classList.add("open");
        return <MobileMenu />;
      } else {
        this.toggleButton.current.classList.remove("open");
        return null;
      }
    }
  };

  render() {
    return (
      <>
        <header>
          <div className="container">
            <div className="row align-items-center">
              <div className="col-5 col-sm-5 col-md-3 col-lg-3 col-xl-2 logoArea">
                <Link to="/dashboard">
                  <img
                    src="/img/ford-gelisim-akademi-logo.png"
                    className="img-fluid"
                    alt="Ford Gelişim Akademi"
                    style={{ marginBottom: "-4%" }}
                  />
                </Link>
              </div>
              <Navigation />
              <div className="col-7 col-sm-7 col-md-4 col-lg-4 col-xl-5 topMenuNatficationArea">
                <ul className="notif">
                  <li>
                    <Guidebar />
                  </li>
                  <li className="natificationSubMenu">
                    <Notificationsbar />
                  </li>
                  <li className="d-none d-md-block d-lg-block">
                    <Profilebar />
                  </li>
                  <LanguageSelector />
                  <li>
                    <div
                      className="menu-toggle"
                      id="menu-toggle"
                      ref={this.toggleButton}
                      onClick={this.toggleMobileMenu}
                    >
                      <span></span>
                      <span></span>
                      <span></span>
                      <span></span>
                    </div>
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </header>
        {this.renderMobileMenu()}
      </>
    );
  }
}

export default withRouter(Header);
